/**
 * @file: 移动操作封装
 * @author: xiaolong.huang@dmall.com
 */

import Visit from '../visit';
import { logic } from './logic';
import { physics } from './physics';
import { physicsUpdateList } from './physicsUpdateList';
import { logicUpdateList } from './logicUpdateList';
import { forceUpdateList } from './forceUpdateList';
import { makeBackMoveTask, makeAddSubBackMoveTask } from './makeBackMoveTask';

let exportObj: FreeObjMap = {
    logic,
    physics,
    physicsUpdateList,
    logicUpdateList,
    forceUpdateList,
    makeBackMoveTask,
    makeAddSubBackMoveTask
};

Visit.Move = exportObj;
export default exportObj;
